import React from "react";
import styles from "./Divider.module.scss";
import clsx from "clsx";
export var DividerThickness;
(function (DividerThickness) {
    DividerThickness["Thick"] = "thick";
    DividerThickness["Thin"] = "thin";
})(DividerThickness || (DividerThickness = {}));
export var DividerLineVariant;
(function (DividerLineVariant) {
    DividerLineVariant["Dashed"] = "dashed";
    DividerLineVariant["Solid"] = "solid";
})(DividerLineVariant || (DividerLineVariant = {}));
export const Divider = (props) => {
    const hasChildren = props.children != null;
    if (props.thickness == DividerThickness.Thick || hasChildren)
        return (React.createElement("div", { className: clsx({
                [styles.Divider]: props.thickness == DividerThickness.Thick,
                [styles.Dashed]: props.lineVariant === DividerLineVariant.Dashed,
            }, hasChildren ? styles.DividerWithChildren : "", props.className) }, props.children));
    return (React.createElement("hr", { className: clsx(styles.SimpleDivider, {
            [styles.Dashed]: props.lineVariant == DividerLineVariant.Dashed,
        }, props.className) }));
};
Divider.defaultProps = {
    thickness: DividerThickness.Thick,
};
//# sourceMappingURL=Divider.js.map